import { useClient } from './client'

import type { SessionJwt } from '@xleddyl/types'
import { jwtDecode } from 'jwt-decode'

export const useGetJwt = () => {
   const session = useSupabaseSession()
   const token = computed(() => session.value?.access_token)
   const client = useClient()

   const decoded = computed(() => (token.value ? jwtDecode<SessionJwt>(token.value) : null))

   if (decoded.value?.user_details?.is_banned) {
      client.auth
         .signOut({
            scope: 'global',
         })
         .finally(() => null)
   }

   return decoded
}
